import UserPanel from "./UserPanel";

export default UserPanel;
